// extracted by mini-css-extract-plugin
var _1 = "ra-footer-accordion";
var _2 = "ra-footer";
var _3 = "ra-footer-inner";
var _4 = "ra-footer-menu";
var _5 = "ra-footer-partners";
var _6 = "ra-footer-section";
var _7 = "ra-footer-social";
export { _1 as "footerAccordionCls", _2 as "footerCls", _3 as "footerInnerCls", _4 as "footerMenuCls", _5 as "footerPartnersCls", _6 as "footerSectionCls", _7 as "footerSocialCls" }
